export default __webpack_public_path__ + "static/media/logo-sm.8d43887b.png";